import './style.scss';

export function specialist_details_block() {
  const block = document.querySelector('.specialist_details_block');
  if (!block) return;
  
}
